// extracted by mini-css-extract-plugin
export default {"high-risk":"HighRisk_high-risk__FD3mJ","contacts-wrap":"HighRisk_contacts-wrap__+LH8r"};